import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
const DropdownForComponents = ({ triggerChild, dropdownChildren, isOpen, propStyles = {}, }) => {
    const ownStyles = {
        relative: {
            flexBasis: 256,
            flexShrink: 0,
            flexGrow: 0,
            width: "100%",
        },
        absolute: {
            top: 0,
            right: 0,
            left: 0,
            rowGap: 4,
        },
    };
    return (_jsx(Box, Object.assign({ position: "relative", style: Object.assign(Object.assign({}, ownStyles.relative), propStyles.relative) }, { children: _jsxs(Box, Object.assign({ position: "absolute", display: "flex", zIndex: 1, style: Object.assign(Object.assign({}, ownStyles.absolute), propStyles.absolute) }, { children: [triggerChild, isOpen && (_jsx(Box, Object.assign({ style: propStyles.dropdown }, { children: dropdownChildren })))] })) })));
};
export default DropdownForComponents;
